import React from 'react';
import { Card, CardContent, Typography, Box, Grid } from '@mui/material';
import { AssignmentTurnedIn } from '@mui/icons-material';
import dayjs from 'dayjs';

import { t } from 'i18next';
import PatientActivePlanTimeline from './PatientActivePlanTimeline';
import UserGroups from './UserGroups';

export default function PatientActivePlan({ plans = [], groups = [] }) {
    const today = dayjs();
    const activePlans = plans.filter(
        (plan) =>
            plan.accepted &&
            dayjs(plan.start_date).isBefore(today, 'day') &&
            dayjs(plan.end_date).isAfter(today, 'day')
    );

    const activePlan = activePlans[0];

    return (
        <>
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} md={6}>
                    <Card
                        elevation={3}
                        sx={{
                            borderRadius: 3,
                            overflow: 'hidden',
                            backgroundColor: '#ffffff'
                        }}
                    >
                        <CardContent sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
                            <Box
                                sx={{
                                    mr: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#1976d2'
                                }}
                            >
                                <AssignmentTurnedIn sx={{ fontSize: 44 }} />
                            </Box>

                            <Box sx={{ flexGrow: 1 }}>
                                {activePlan ? (
                                    <>
                                        <Typography variant="h5" fontWeight={600}>
                                            {activePlan.name}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            fontWeight={500}
                                        >
                                            {t('userPage.plan.active')}
                                        </Typography>
                                    </>
                                ) : (
                                    <>
                                        <Typography variant="h5" fontWeight={600}>
                                            {t('userPage.plan.none')}
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                        >
                                            {t('userPage.plan.noneDescription')}
                                        </Typography>
                                    </>
                                )}
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12} md={6}>
                    <UserGroups groups={groups} />
                </Grid>
            </Grid>

            {activePlan && <PatientActivePlanTimeline plans={[activePlan]} />}
        </>
    );
}
